import { adminVerificationQueryKeys as e } from "./adminVerificationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { verificationApi as n } from "@maat/api-main";
//#region src/verification/admin/useAdminVerificationStatsQuery.ts
var r = () => t({
	queryKey: e.stats(),
	queryFn: () => n.adminVerificationStats()
});
//#endregion
export { r as useAdminVerificationStatsQuery };
